<template>
  <BaseDataList ref="dataList" :items="accOrders" :service="fetchAccOrders">
    <template #header>
      <AccOrderListHeader />
    </template>

    <template #default="{ item }">
      <AccOrderListItem :acc-order="item" />
    </template>
  </BaseDataList>
</template>

<script>
import { contactAccOrdersClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import AccOrderListHeader from './AccOrderListHeader.vue';
import AccOrderListItem from './AccOrderListItem.vue';

export default {
  components: {
    AccOrderListHeader,
    AccOrderListItem,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      accOrders: [],
    };
  },
  methods: {
    resetList() {
      this.$refs.dataList.resetList();
    },
    async fetchAccOrders(params = {}) {
      try {
        const response = await contactAccOrdersClient.list(this.contactId, {
          ...params,
          include: 'lineItemsSumQuantity',
        });

        this.accOrders = mapKeysToCamelCase(response?.data || []);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
